import { render, staticRenderFns } from "./shipworks.vue?vue&type=template&id=cc932e5c&scoped=true"
import script from "./shipworks.vue?vue&type=script&lang=js"
export * from "./shipworks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc932e5c",
  null
  
)

export default component.exports